import { makeStyles } from '@mui/styles';

import { IAlyceCustomTheme } from '../../../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette }) => ({
  sidebarHeaderRoot: {
    backgroundColor: palette.customStyling.backgroundColor,
    color: palette.customStyling.headlineColor,
  },
  sidebarHeaderIcon: {
    color: palette.customStyling.headlineColor,
  },
  merchantLink: {
    color: palette.customStyling.highlightColor,
  },
  dotActive: {
    backgroundColor: palette.customStyling.highlightColor,
  },
}));

export default useStyles;
